import { memo as Memo, useMemo, useState, useEffect, useRef } from 'react'

//* HOC's
import { withDataContext } from 'context'
import { useRouter } from 'next/router'

//* Components
import { Page, AnimationWrapp } from 'components/common'
import { CompanyInfo, CatalogView, BusinessSection } from 'components/pages'
import CompanyStyle from 'styles/pages/CompanyStyle'

//* Helpers
import { config, arrayGenChild, arrayGen } from 'helpers'

const CompanyProjects = Memo(({ pages, pageParams, selectedLang, preloader, ...props }) => {
    //! Router
    const router = useRouter()

    //! State
    const [secObj, setSecObj] = useState()

    //! Page Data
    const pageData = useMemo(() => pages?.[pageParams.name]?.[selectedLang], [pages, selectedLang, pageParams.name])
    const companyData = useMemo(
        () => props[pageParams.singleType]?.[router.query.slug]?.[selectedLang],
        [props?.[pageParams.singleType], router, selectedLang]
    )

    //! ref
    const topRef = useRef()
    const catalogViewRef = useRef()
    const Ref4 = useRef()

    useEffect(() => {
        if (pageData && companyData && topRef?.current && catalogViewRef?.current && Ref4.current && !preloader) {
            setSecObj([
                arrayGenChild(topRef.current[0].current.firstChild.childNodes),
                arrayGen([topRef.current[1].current.childNodes]),
                arrayGenChild(catalogViewRef.current[0].current.childNodes[0].childNodes),
                catalogViewRef.current[2].current.childNodes,
                catalogViewRef.current[3].current,
                arrayGenChild(Ref4.current[0][0].childNodes),
                Ref4.current[1].current,
                Ref4.current[2].current,
            ])
        }
    }, [topRef.current, catalogViewRef.current, Ref4.current, router, pageData, companyData, preloader])

    return (
        <CompanyStyle>
            <Page
                className='company-projects'
                meta={{
                    title: companyData?.company?.meta.title,
                    description: companyData?.company?.meta.description,
                    keywords: companyData?.company?.meta.keywords,
                    image: companyData?.company.meta_image,
                }}
            >
                {companyData && (
                    <AnimationWrapp state={secObj}>
                        <CompanyInfo
                            ref={topRef}
                            backPage={'investmentProjects'}
                            id={companyData.company.id}
                            companyName={companyData.company.name}
                            companyType={companyData.company.type}
                            companyInfo={companyData.company.short_description}
                            projectsCompany={true}
                            backURL={config.routes.investmentProjects.path}
                        />
                        <CatalogView
                            ref={catalogViewRef}
                            notLast={true}
                            inProductSubmission={true}
                            singleInvest={true}
                            title={'companyProjects'}
                            catalogsArr={companyData.projects}
                        />
                        <BusinessSection
                            ref={Ref4}
                            inCompany={true}
                            title={pageData.contact_section?.title}
                            text={pageData.contact_section?.text}
                            photo={pageData.contact_section?.image || '/images/services/business.png'}
                        />
                    </AnimationWrapp>
                )}
            </Page>
        </CompanyStyle>
    )
})

export default withDataContext(CompanyProjects, ['pages', config.routes.projectsCompanySingle.singleType])
